import { Partner } from '~/data/common'
import { HomeEquityColdRequest } from '~/data/loans/home-equity/cold-offer'

const zilicredFilters = (
  lastRequest: HomeEquityColdRequest,
  extraQuestions,
  score: number,
): boolean => {
  return (
    score >= 250 &&
    (lastRequest?.monthly_income || 0) >= 3750 &&
    extraQuestions?.collateral_type === 'Residencial'
  )
}

export const getHomeEquityPayrollAffiliates = (
  lastRequest: HomeEquityColdRequest,
  extraQuestions,
  score: number,
): Record<Partner | string, boolean> => {
  return {
    [Partner.ZILICRED]: zilicredFilters(lastRequest, extraQuestions, score),
  }
}
